// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".charts-sdk-select .vs__deselect{fill:#e5e5e5;margin-left:5px}.charts-sdk-select .vs__selected{color:#fff;background-color:#1b3d5e!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
